import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';
import styles from './styles.module.css';
import BlogSearch from '../BlogSearch';
import { setState } from '@/commonTypes';
import { useTranslations } from 'next-intl';

export default function BlogsHero({ setPageNumber }: { setPageNumber: setState<number | string> }) {
  const tCommon = useTranslations('common');

  return (
    <>
      <Breadcrumb items={[{ label: tCommon('homeTitle'), to: '/' }, { label: tCommon('seo.blog.title') }]} />
      <SectionHead
        title={'دانش خودرو، ساده و هوشمند'}
        text={
          'راهنماها، تحلیل‌ها و اخبار دنیای خودرو — از خلافی و بیمه تا هوش مصنوعی و معاملهٔ امن، همه در یک‌جا.'
        }
        tag={'مجلهٔ کارا'}
        headingTag="h1"
        type="otherPages"
        // titleClass={`${styles.titleClass}`}
      />

      <BlogSearch setPageNumber={setPageNumber} />
    </>
  );
}
